import React from 'react';
import propTypes from 'prop-types';
import './messageview.css';

const MessageView = props => (
  <div className="message-container">
    <div className="top-section">
      <div className={`icon ${props.icon}`} />
      <div className="message">{props.message}</div>
      <div className="submessage">{props.submessage}</div>
    </div>

    <div className="bottom-section">
      <div className="callback">Any queries? Reach out to us at <a href="https://api.whatsapp.com/send/?phone=919008111144&text=Hi&type=phone_number&app_absent=0">+91-9008111144</a></div>
      <div className="oh-logo-footer-new" />
    </div>

  </div>
);

MessageView.propTypes = {
  message: propTypes.string,
  submessage: propTypes.string,
  icon: propTypes.string,
};

export default MessageView;
